import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

export default class extends Controller {
  static debounces = ["fetchBOLs", "fetchPOs", "fetchSuppliers"];
  static targets = [
    "PoSearchInput",
    "PoDropdown",
    "PoList",
    "SupplierSearchInput",
    "SupplierDropdown",
    "SupplierList",
    "BolIdInput",
    "PurchaseOrderIdInput",
    "OrderIdInput",
    "CarrierNameInput",
    "CustomerNameInput",
    "CustomerCompanyInput",
    "CustomerStreetInput",
    "CustomerCityInput",
    "CustomerStateInput",
    "CustomerZipInput",
    "CustomerPhoneInput",
    "SupplierNameInput",
    "SupplierStreetInput",
    "SupplierCityInput",
    "SupplierStateInput",
    "SupplierZipInput",
    "IsHybrid85Input",
    "PoNumberInput",
    "TrackingReferenceNumberInput",
  ];

  connect() {
    this.element[this.identifier] = this;
    useDebounce(this);

    this.PoSearchInputTarget.addEventListener("input", (e) => {
      this.fetchPOs(e.target.value);
    });
    this.SupplierSearchInputTarget.addEventListener("input", (e) => {
      this.fetchSuppliers(e.target.value);
    });

    this.PoListTarget.addEventListener("click", (e) => {
      if (e.target.tagName === "LI") {
        const poData = JSON.parse(decodeURIComponent(escape(atob(e.target.getAttribute("data-po")))));
        this.handlePoSelect(poData);
        this.PoDropdownTarget.classList.add("hidden");
      }
    });
    this.SupplierListTarget.addEventListener("click", (e) => {
      if (e.target.tagName === "LI") {
        const supplierData = JSON.parse(decodeURIComponent(escape(atob(e.target.getAttribute("data-supplier")))));
        this.handleSupplierSelect(supplierData);
        this.SupplierDropdownTarget.classList.add("hidden");
      }
    });
  }

  async fetchPOs(search) {
    const response = await fetch(`/admin/purchase_orders/search?query=${search}`, {
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    this.updatePoDropdown(data);
  }

  async fetchSuppliers(search) {
    const response = await fetch(`/admin/seed_suppliers/search?query=${search}`, {
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    this.updateSupplierDropdown(data);
  }

  updatePoDropdown(pos) {
    console.log("pos", pos);
    this.PoListTarget.innerHTML = pos.map((po) => `<li class="p-2 cursor-pointer hover:bg-gray-200" data-id="${po.id}" data-po='${btoa(unescape(encodeURIComponent(JSON.stringify(po))))}'>${po.id} - ${po.number} - ${po.customer_name}</li>`).join("");
    if (pos.length > 0) {
      this.PoDropdownTarget.classList.remove("hidden");
    } else {
      this.PoDropdownTarget.classList.add("hidden");
    }
  }

  updateSupplierDropdown(suppliers) {
    console.log("suppliers", suppliers);
    this.SupplierListTarget.innerHTML = suppliers.map((supplier) => `<li class="p-2 cursor-pointer hover:bg-gray-200" data-id="${supplier.id}" data-supplier='${btoa(unescape(encodeURIComponent(JSON.stringify(supplier))))}'>${supplier.id} - ${supplier.name}</li>`).join("");
    if (suppliers.length > 0) {
      this.SupplierDropdownTarget.classList.remove("hidden");
    } else {
      this.SupplierDropdownTarget.classList.add("hidden");
    }
  }

  handlePoSelect(po) {
    // Your existing code for handling the selected PO and updating the form fields
    console.log("po: ", po);
    this.CarrierNameInputTarget.value = "";
    this.IsHybrid85InputTarget.value = po.order.is_hybrid85;
    this.PoNumberInputTarget.value = po.number;
    this.CustomerNameInputTarget.value = po.customer_name;
    this.CustomerCompanyInputTarget.value = po.order.company_name;
    this.CustomerStreetInputTarget.value = po.order.shipping_address;
    this.CustomerCityInputTarget.value = po.order.shipping_city;
    this.CustomerStateInputTarget.value = po.order.shipping_state;
    this.CustomerZipInputTarget.value = po.order.shipping_zipcode;
    this.CustomerPhoneInputTarget.value = po.order.phone_number;
    this.PurchaseOrderIdInputTarget.value = po.id;
  }

  handleSupplierSelect(supplier) {
    // Your existing code for handling the selected supplier and updating the form fields
    console.log("supplier: ", supplier);
    this.SupplierNameInputTarget.value = supplier.name;
    this.SupplierStreetInputTarget.value = supplier.address;
    this.SupplierCityInputTarget.value = supplier.city;
    this.SupplierStateInputTarget.value = supplier.state;
    this.SupplierZipInputTarget.value = supplier.zipcode;
  }
}
